import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { useTranslation } from 'react-i18next';

import { Container } from './styles';

const FileDropZone = ({ handleChangeFile, onDropRejected }) => {
  const { t } = useTranslation();

  const onDrop = useCallback((files) => handleChangeFile(files[0]), [handleChangeFile]);

  const useDropzoneConfig = {
    onDrop,
    onDropRejected,
    maxFiles: 1,
    accept: '.mdb',
  };

  const {
    getRootProps, getInputProps,
  } = useDropzone(useDropzoneConfig);

  return (
    <Container {...getRootProps()}>
      <input {...getInputProps()} />
      <p>
        {t('components.fileDropZone.defaultMessagePart1')}
        <b>{t('components.fileDropZone.defaultMessageBoldPart')}</b>
        {t('components.fileDropZone.defaultMessagePart2')}
      </p>
      <span>{t('components.fileDropZone.defaultMessageLink')}</span>
    </Container>
  );
};

FileDropZone.propTypes = {
  handleChangeFile: PropTypes.func.isRequired,
  onDropRejected: PropTypes.func,
};

FileDropZone.defaultProps = {
  onDropRejected: () => {},
};

export default FileDropZone;
